import React, { useState, useEffect } from "react";
import NavLinks from "../Navbar/NavLinks";
import { HashLink } from "react-router-hash-link";
import Logo from "../../images/logo.png";
import LogoWhite from "../../images/logo-white.png";

const NavBar = () => {
  const [top, setTop] = useState(window.scrollY<50);
  const [isOpen, setisOpen] = React.useState(false);

  function handleClick() {
    setisOpen(!isOpen);
  }

  useEffect(() => {
    const scrollHandler = () => {
      const scrolled = window.pageYOffset > 50;
      
      setTop(!scrolled);
    };
    
    window.addEventListener("scroll", scrollHandler);

    scrollHandler(); 

    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  return (
    <nav
      className={`fixed top-0 w-full z-30 transition duration-300 ease-in-out mb-16 ${
        !top ? "bg-primary shadow-lg" : ""
      }`}
    >
      <div className="flex flex-row justify-between items-center py-2">
        <div className="flex w-full md:w-1/2 flex-row justify-start px-5 md:px-12 md:items-center text-left font-semibold">
          <HashLink smooth to="/#" className="w-full">
            <div className="w-full flex justify-start align-middle gap-3 md:items-center md:justify-start align-middle text-primary">
              <h1
                className={`opacity-80 mt-0 md:text-3xl text-3xl self-center font-impact ${
                  !top && "text-white"
                }`}
              >
                NAUTIK AGORA É{" "}
              </h1>
              <img
                src={top ? Logo : LogoWhite}
                alt="Nautex"
                className="mb-3 w-full md:w-[150px] h-auto self-center max-w-[150px]"
              />
            </div>
          </HashLink>
        </div>
        <div className="group flex flex-col items-end w-24 mr-2 md:w-1/2 md:px-12">
          <button
            className={`p-2 rounded-lg z-50 lg:hidden ${
              top
                ? "text-primary hover:text-gray-400"
                : "text-white"
            }`}
            onClick={handleClick}
          >
            <svg
              className="h-6 w-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              {isOpen && (
                <path
                  stroke="black"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                />
              )}
              {!isOpen && (
                <path
                  fill="currentColor"
                  fillRule="evenodd"
                  d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                />
              )}
            </svg>
          </button>
          <div className="hidden space-x-6 lg:inline-block p-3">
            <NavLinks invertColors={!top} />
          </div>

          <div
            className={`fixed transition-transform duration-300 ease-in-out transit flex justify-center left-0 w-full h-auto rounded-md p-24 bg-white lg:hidden shadow-xl top-0 ${
              isOpen ? "block" : "hidden"
            } `}
          >
            <div className="flex flex-col space-y-6">
              <NavLinks invertColors={!top} />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;